import React, { useState } from "react";
import Input from "../../Components/Input";
import DateInput from "../../Components/DateInput";
import Dropdown from "../../Components/Dropdown";
import Loader from "../../Components/Loader";
import ExpenseApprovalsController from "../Controllers/ExpenseApprovalsController";
import filterIcon from "../../Assets/Icons/filter.png";
import leftBtuIcon from "../../Assets/Icons/back.png";
import TextInput from "../../Components/TextInput";
import searchIcon from "../../Assets/Icons/search.png";
import AddExpenseModal from "../Components/AddExpenseModal";
import downArrow from "../../Assets/Icons/chevron-down.png";
import { convertGMTToLocal } from "../../Utils/Validation";

const ExpenseApprovalsScreen = ({ expenseApproveList, expenseApproveLoading, expenseApproveError, onRefresh, fetchExpenseApprove }) => {
    const {
        showModal,
        closeModal,
        expenseInfoRef,
        filters,
        setFilters,
        handleChange,
        applyFiltersApproveList,
        resetFilters,
        openDropdown,
        toggleDropdown,
        dropdownRefs,
        filteredExpenses,
        currentPage,
        totalPages,
        visiblePages,
        loading,
        statusOptions,
        handlePageChange,
        handleSearchEmployee,
        handleSelectEmployee,
        employeeList,searchListRef,
        employeeLoading,
        employeeError, filterError,
        handleApproveReject, handleShowApprovedList,
        expenseListError,
        handleViewExpense,
        filterOnRefresh
    } = ExpenseApprovalsController(expenseApproveList, onRefresh, fetchExpenseApprove);

    const [showFilters, setShowFilters] = useState(false);
    console.log('employeeList?.length:', filteredExpenses?.length)

    return (
        <div>
            <div className="flexdisplaybetween" style={{ paddingBottom: 10 }}>

                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <h2 className="tab-componrnt-title">Expense Approvals</h2>
                    <div className="approval-count-badge">
                        {expenseApproveList?.length || 0}
                    </div>

                </div>
                <div style={{ cursor: "pointer", color: "#5A55D2", fontSize: "12px", textDecoration: 'underline' }} onClick={handleShowApprovedList}>
                    Show Approved Expenses
                </div>
            </div>
            {showModal && <AddExpenseModal isOpen={showModal} onClose={closeModal} editData={expenseInfoRef.current} onValueChange={filterOnRefresh} />}

            {/* Filters */}
            <div style={styles.container}>
                <div style={styles.filtersHeader}>
                    <button style={styles.filterButton} onClick={() => setShowFilters(!showFilters)}>
                        <img src={filterIcon} alt="Filter" style={{ marginRight: '8px', width: 12 }} />
                        <span>Filters</span>
                    </button>
                    <div>
                        <img src={leftBtuIcon} style={styles.arrowBtn} alt="Prev" />
                        <img src={leftBtuIcon} style={{ ...styles.arrowBtn, transform: 'rotate(180deg)' }} alt="Next" />
                    </div>
                </div>
            </div>

            {showFilters && (
                <div className="tasksScreen-filters-container tasksScreen-open-filters">
                    <div className="tasksScreen-filters">
                        <div ref={searchListRef} className="filter-field" style={{ width: '100%' }}>
                            <label style={{ ...styles.labaleStyle, display: 'block', }}>
                                Employee Name
                            </label>
                            <TextInput
                                label="Employee Name"
                                placeholder="Search Employee"
                                value={filters.employee}
                                onChange={(e) => handleChange("employee", e.target.value)}
                                onRightClick={handleSearchEmployee}
                                right={
                                    employeeLoading ? (
                                        <Loader loading={true} color="var(--primary-loader-color)" size="small" />
                                    ) : (
                                        <img src={searchIcon} alt="Search" style={{ cursor: "pointer", height: 18, width: 18 }} />
                                    )
                                }
                                style={{ padding: "8px 10px" }}
                                errorMessage={employeeError}
                            />

                            {employeeList.length > 0 && (
                                <ul style={styles.dropdownList}>
                                    {employeeList.map((emp, index) => (
                                        <li
                                            key={emp.emp_id}
                                            onClick={() => handleSelectEmployee(emp)}
                                            style={{
                                                ...styles.dropdownItem,
                                                borderBottom: index !== employeeList.length - 1 ? "1px solid #ccc" : "none",
                                            }}
                                        >
                                            {emp.emp_name}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        <div className="filter-field">
                            <label style={{ ...styles.labaleStyle, display: "block" }}>Expense Date</label>
                            <DateInput
                                label="Expense Date"
                                value={filters.date}
                                onChange={(e) => handleChange("date", e.target.value)}
                                // max={new Date().toLocaleDateString("en-CA")}
                            // width={220}
                            /></div>
                        <Input
                            label="Amount"
                            inputType="number"
                            placeholder="Enter amount"
                            value={filters.amount}
                            onChange={(e) => handleChange("amount", e.target.value)}
                            width={220}
                        />
                        <Dropdown
                            ref={(el) => (dropdownRefs.current["status"] = el)}
                            isOpen={openDropdown === "status"}
                            toggleDropdown={() => toggleDropdown("status")}
                            options={statusOptions}
                            value={filters.status}
                            onChange={(val) => handleChange("status", val)}
                            label="Status"
                            width={220}
                        />
                    </div>
                    <div className="tasksScreen-filter-buttons">
                        <button className="tasksScreen-apply-button" onClick={applyFiltersApproveList} 
                        style={{ cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.5 : 1 }} disabled={loading}>
                            Apply
                        </button>
                        <button className="tasksScreen-cancel-button" onClick={() => { resetFilters(); setShowFilters(false) }}>
                            Cancel
                        </button>
                        <button className="tasksScreen-reset-button" onClick={resetFilters}>
                            Reset
                        </button>
                        {filterError && <div className="list-error-msg">{filterError} </div>}
                    </div>
                </div>
            )}

            <div className="tasksScreen-task-table-wrapper">
                <table className="tasksScreen-task-table">
                    <thead>
                        <tr>
                            <th>Expense Name</th>
                            <th>Applied Date</th>
                            <th style={{ textAlign: 'end' }}>Total Amount</th>
                            <th>Comment</th>
                            <th>Added By</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody style={{ background: '#FFFFFF' }}>
                        {loading ? (
                            <tr><td colSpan="8"><Loader loading={loading} color={'var(--primary-loader-color)'} /></td></tr>
                        ) : (
                            filteredExpenses.map((item, idx) => (
                                <tr key={idx}>
                                    <td>{item?.expense_name || '--'}</td>
                                    <td>{item?.created_at ? convertGMTToLocal(item?.created_at, 'dd/MM/yyyy') : '--'}</td>
                                    <td style={{ textAlign: 'end' }}>{item?.amount ? Number(item?.amount).toFixed(2) : '--'}</td>
                                    <td>{item?.comment || '--'}</td>
                                    <td>{item?.added_by || '--'}</td>
                                    <td>
                                        {item?.expense_status_name === "Approval Pending" ? (
                                            <span onClick={() => { handleApproveReject(item) }} style={{ color: "#5A55D2", textDecoration: "underline", cursor: "pointer" }}>Approve/Reject</span>
                                        ) : (
                                            <span onClick={() => { handleViewExpense(item) }} style={{ color: "#5A55D2", textDecoration: "underline", cursor: "pointer" }}>View</span>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            {expenseApproveLoading && <Loader loading={expenseApproveLoading} color={'var(--primary-loader-color)'} />}
            {expenseApproveError && <div className="list-error-msg">{expenseApproveError} </div>}
            {expenseListError && <div className="list-error-msg">{expenseListError} </div>}

            {/* Pagination */}
            <div className="tasksScreen-table-footer">
                <span className="tasksScreen-pagination-info">{`${currentPage}-${totalPages} of items`}</span>
                <div className="tasksScreen-pagination">
                    <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        <img src={downArrow} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image" />
                    </button>
                    {visiblePages.map((page) => (
                        <button
                            key={page}
                            className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
                            onClick={() => handlePageChange(page)}
                        >
                            {page}
                        </button>
                    ))}
                    <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image" />
                    </button>
                </div>
            </div>
        </div>
    );
};
const styles = {
    container: {
        padding: "5px",
        backgroundColor: "#f8f9fa",
        border: "1px #EFF0F4 solid",
    },
    filtersHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    filterButton: {
        backgroundColor: "white",
        color: "var(--button-bg-color)",
        border: "1px var(--button-bg-color) solid",
        padding: "7px 13px",
        cursor: "pointer",
        borderRadius: "20px",
        fontSize: "12px",
        fontWeight: "400",
        fontFamily: "Roboto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    arrowBtn: {
        marginRight: "5px",
        cursor: "pointer",
        width: "28px",
        height: "28px",
    },
    dropdownList: {
        position: "absolute",
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        borderRadius: "4px",
        maxHeight: "200px",
        overflowY: "auto",
        zIndex: 1000,
        padding: 0,
        margin: 0,
        listStyleType: "none",
        width: "220px"
    },
    dropdownItem: {
        padding: "10px",
        cursor: "pointer",
        backgroundColor: "#fff",
    },
};
export default ExpenseApprovalsScreen;
